<div class="preview-header">
  <div class="preview-titles">
    <h2 mat-dialog-title class="preview-title">{{ title }}</h2>
    @if (details) {
      <p class="preview-details">{{ details }}</p>
    }
  </div>
  <button mat-icon-button (click)="close()" aria-label="Close image preview" class="preview-close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="preview-body">
  <!--
    The attachment's own state is asked first, and whether we happen to hold a URL second. A
    rejected draft still carries the browser-local blob it was previewed from, so testing for a URL
    first rendered an image the user cannot see and explained nothing, while an intact restored
    image whose signed URL had not arrived was declared lost. One order gets both right.
  -->
  @if (isUnavailable) {
    <div class="preview-unavailable">
      <mat-icon aria-hidden="true">broken_image</mat-icon>
      <p>{{ unavailableMessage }}</p>
    </div>
  } @else if (data.previewUrl) {
    <img [src]="data.previewUrl" [alt]="imageAlt" class="preview-image" />
  } @else {
    <div class="preview-unavailable">
      <mat-icon aria-hidden="true">hourglass_empty</mat-icon>
      <p>This image could not be loaded just now. Close this and open it again.</p>
    </div>
  }
</mat-dialog-content>
